













import { Component, Mixins, Prop } from "vue-property-decorator";
import { RangeOfMotionTextEditableObjectMixin } from "./mixins";
import FilterableTextInput from "../../../drawing/FilterableTextInput.vue";

@Component({
  components: {
    FilterableTextInput,
  },
})
export default class RangeOfMotionRomInput extends Mixins(
  RangeOfMotionTextEditableObjectMixin,
) {
  data() {
    return {
      hasFocus: false,
    };
  }
  hasFocus: boolean;

  @Prop()
  description: string;

  onFocus(): void {
    this.hasFocus = true;
    this.emitFocus();
  }

  onBlur(): void {
    this.hasFocus = false;
  }

  get additionalStyleProperties(): any {
    if (!this.hasFocus) { return null; }
    return {
      backgroundColor: "white",
    };
  }

  get isVisible(): boolean {
    return this.editingSource.isVisible;
  }
}
